<loading-indicator [show]="!formReady || saving"></loading-indicator>

<div [formGroup]="formData" class="generatedHTMLWindow generatedHTMLForm angularForm" *ngIf="formReady">
  <div class="formHeader">
    <span class="navigateBtn navigate-left" (click)="previous()" *ngIf="showPrevBtn && currentOid > 0">
      <svg-icon title="{{'navigation.previous' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
    <span class="headerTitle">{{ 'projectValuation.valuationEventDetails' | translate }}</span>
    <ng-container *ngIf="formData.controls['ParentId'] as ParentId">
      <ng-container *ngIf="formData.controls['ParentValuationEventName'] as ParentValuationEventName">
        <span class="description" *ngIf="ParentValuationPortfolioName || ParentId > 0">{{ 'projectValuation.childOf' | translate }} ({{ParentValuationEventName}})</span>
      </ng-container>
    </ng-container>
    <span class="navigateBtn navigate-right" (click)="next()" *ngIf="showNextBtn && currentOid > 0">
      <svg-icon title="{{'navigation.next' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
  </div>

  <div class="generatedHTMLRoot">
    <div class="mainSection">
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'projectValuation.portfolioInformation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.projectID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ProjectID"
                                      #projectRetriever
                                      [data]="retrieverData.Project"
                                      textField="projectName"
                                      [filterable]="true"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="applyProjectName()"
                                      id="form-pUID">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent" *ngIf="formData.controls['ValuationPortfolioName'] as ValuationPortfolioName">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.valuationPortfolioName' | translate }}</span>
                  <span *ngIf="ValuationPortfolioName.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="ValuationPortfolioName.invalid">
                  <input type="text" formControlName="ValuationPortfolioName" kendoTextBox id="form-valuationPortfolioName" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.valuationDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ValuationDate" [format]="dateFormat" id="form-valuationDate"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.valuationStatus' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ValuationStatusId"
                                      [data]="reflistData.ref_portfolio_valuation_status"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-valuationStatusId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent" *ngIf="formData.controls['VolumeOfValuation'] as VolumeOfValuation">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.volumeOfValuation' | translate }} | {{currency}}</span>
                  <span *ngIf="VolumeOfValuation.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="VolumeOfValuation.invalid">
                  <kendo-numerictextbox formControlName="VolumeOfValuation" format="n0" [spinners]="false" id="form-VolumeOfValuation"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.liabilityTypeId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="LiabilityTypeId"
                                      [data]="reflistData.ref_l2_liability_type"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-liabilityTypeProject">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.niy' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="niy" format="n2" [spinners]="false" id="form-niy"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.ney' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ney" format="n2" [spinners]="false" id="form-ney"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.nry' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="nry" format="n2" [spinners]="false" id="form-nry"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width66percent" *ngIf="formData.controls['ClientManual'] as ClientManual">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.clientManual' | translate }}</span>
                  <span *ngIf="ClientManual.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="ClientManual.invalid">
                  <input type="text" formControlName="ClientManual" kendoTextBox id="form-clientmanual" />
                </div>
              </div>
              <div class="field width66percent" *ngIf="formData.controls['Reference'] as Reference">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.reference' | translate }}</span>
                  <span *ngIf="Reference.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="Reference.invalid">
                  <input type="text" formControlName="Reference" kendoTextBox id="form-reference" />
                </div>
              </div>
              <div class="field width33percent" *ngIf="formData.controls['SignedBy'] as SignedBy">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.signedBy' | translate }}</span>
                  <span *ngIf="SignedBy.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="SignedBy.invalid">
                  <input type="text" formControlName="SignedBy" kendoTextBox id="form-signedby" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.signedAndReceivedOn' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="SignedAndReceivedOn" [format]="dateFormat" id="form-signedandreceivedon"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.deadlineDraft' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="deadlineDraft" [format]="dateFormat" id="form-deadline-draft"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.deadlineFinal' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="deadlineFinal" [format]="dateFormat" id="form-deadline-final"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.instructionDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="InstructionDate" [format]="dateFormat" id="form-instructiondate"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.reportDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ReportDate" [format]="dateFormat" id="form-reportdate"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.businessLineNrId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="BusinessLineNrId"
                                      [data]="reflistData.ref_valuation_businesslinenr"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-businessLine">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.derivationsFromInstructionLetter' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="DerivationsFromInstructionLetterId"
                                      [data]="reflistData.ref_l2_deviations_from_instruction"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-derivationsfrominstructionletter">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent" *ngIf="formData.controls['Derivations'] as Derivations">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.derivations' | translate }}</span>
                  <span *ngIf="Derivations.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="Derivations.invalid">
                  <input type="text" formControlName="Derivations" kendoTextBox id="form-derivations" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.remark' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Remark" kendoTextBox id="form-remark" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.oid' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="number" formControlName="Oid" kendoTextBox id="form-vP-UID" />
                  <input *ngIf="isNew" type="text" formControlName="filledOnSave" kendoTextBox id="form-vP-UID" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.jjlJobId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="JllJobId" kendoTextBox id="form-jll-job-id" />
                </div>
              </div>
              <div class="field width33percent" *ngIf="formData.controls['NumberOfPropertiesManually'] as NumberOfPropertiesManually">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'valuationPortfolio.numberOfProperties' | translate }}</span>
                  <span *ngIf="NumberOfPropertiesManually.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="NumberOfPropertiesManually.invalid">
                  <div class="half-field-left">
                    <kendo-numerictextbox formControlName="NumberOfPropertiesManually" format="n0" [spinners]="false" id="form-no.OfPropertiesManually"></kendo-numerictextbox>
                  </div>
                  <div class="half-field-right">
                    <kendo-numerictextbox formControlName="NumberOfPropertyCalc" format="n0" [spinners]="false" id="form-no.OfPropertiesSystem"></kendo-numerictextbox>
                  </div>
                </div>
              </div>
              <div class="field width33percent" *ngIf="formData.controls['Client'] as Client">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'valuationPortfolio.client' | translate }}</span>
                  <span *ngIf="Client.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="Client.invalid">
                  <input type="text" formControlName="Client" kendoTextBox id="form-client" />
                </div>
              </div>
              <div class="field width66percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.periodOfValuationID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="PeriodOfValuationID"
                                      [data]="reflistData.ref_valuation_project_periodofvaluation"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-periodOfValuation">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width66percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.recordStatusId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="RecordStatusId"
                                      [data]="reflistData.ref_recordstatus"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="datasetStatusUpdated($event)"
                                      id="form-currency">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'projectValuation.argusSyncStatusTitle' | translate | uppercase}}</span>
          <svg-icon src="./assets/icons/download_export.svg" align="center" class="menu-action-icon-argus-sync svg-icon-gray action-icon disabled" title="EXPORT TO ARGUS"></svg-icon>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.lastPushStatus' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="LastSyncStatus" kendoTextBox id="form-lastSyncStatus" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.lastPushedDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker *ngIf="formData.controls['LastSyncStatus'].value !== 'NOT SYNCED'" [format]="dateFormat" formControlName="LastSync" id="form-lastSync"></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.pushedBy' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="formData.controls['LastSyncStatus'].value !== 'NOT SYNCED'" type="text" formControlName="SyncBy" kendoTextBox id="form-syncBy" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.propertiesPushed' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="formData.controls['LastSyncStatus'].value !== 'NOT SYNCED'" type="text" formControlName="PropertiesSynced" kendoTextBox id="form-propertiesSynced" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.portfolioId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="formData.controls['LastSyncStatus'].value !== 'NOT SYNCED'" type="text" formControlName="ArgusPortfolioId" kendoTextBox id="form-argusPortfolioId" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'projectstd.valuationReportsDefaultConfiguration' | translate | uppercase }}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent" *ngIf="formData.controls['TemplateId'] as TemplateId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.languageDefinition' | translate }}</span>
                  <span *ngIf="TemplateId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="TemplateId.invalid">
                  <kendo-dropdownlist formControlName="LanguageId"
                                      [data]="availableLanguageDefinitions"
                                      textField="description"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (valueChange)="filterTemplatesByLanguage($event)"
                                      id="form-templateId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent" *ngIf="formData.controls['TemplateId'] as TemplateId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.templateId' | translate }}</span>
                  <span *ngIf="TemplateId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="TemplateId.invalid">
                  <kendo-dropdownlist formControlName="TemplateId"
                                      [data]="filteredAvailableTemplates"
                                      textField="Name"
                                      valueField="Oid"
                                      [valuePrimitive]="true"
                                      id="form-templateId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent" *ngIf="formData.controls['LeadingMethodId'] as LeadingMethodId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.leadingMethod' | translate }}</span>
                  <span *ngIf="LeadingMethodId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="LeadingMethodId.invalid">
                  <kendo-dropdownlist formControlName="LeadingMethodId"
                                      [data]="reflistData.ref_l3_leading_method"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-leading-method">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width25percent" *ngIf="formData.controls['DisplayValuesOverTimeId'] as DisplayValuesOverTimeId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.displayValuesOverTimeId' | translate }}</span>
                  <span *ngIf="DisplayValuesOverTimeId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="DisplayValuesOverTimeId.invalid">
                  <kendo-dropdownlist formControlName="DisplayValuesOverTimeId"
                                      [data]="reflistData.ref_l3_display_values_over_time"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-displayValuesOverTime">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'projectValuation.systemInformation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.ownerUserID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerUserID"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.dateCreated' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="DateCreated" [format]="dateFormat" id="form-createdAt"></kendo-datepicker>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.ownerBuID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerBuID"
                                      [data]="reflistData.config_business_units"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdByBu">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.modifiedByUserID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ModifiedByUserID"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-modifiedBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.historyLastEntry' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="HistoryLastEntry" [format]="dateFormat" id="form-modifiedAt"></kendo-datepicker>
                </div>
              </div>

              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectValuation.modifiedBuID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ModifiedBuID"
                                      [data]="reflistData.config_business_units"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-modifiedByBu">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="formData.controls['Oid'] as Oid">
        <div class="section" style="width: 50%">
          <valuation-event-properties *ngIf="Oid && Oid.value > 0"
                                      [compsOptions]="true"
                                      [portfolioOid]="Oid.value"
                                      [data]="propertiesListReferenceData"
                                      [canClose]="false"
                                      [detailForm]="true">
          </valuation-event-properties>
        </div>
      </ng-container>
    </div>
  </div>
</div>
